import { API_URL } from "./Axios";

export const serviceDivision = [
    { value : "1", label : "시공"},
    { value : "2", label : "A/S"},
    // 이동 시공(division=3) - 향후 복구 대비 코드 보존, UI 비활성화
    // { value : "3", label : "이동 시공"},
    { value : "4", label : "탈거"},
];

// 기존 예약 라벨 표시용 (3번 이동시공 포함, 백엔드 응답 호환)
export const serviceDivisionLabelMap: { [key: string]: string } = {
    "1": "시공",
    "2": "A/S",
    "3": "이동 시공",
    "4": "탈거",
};

export const varHighStatus = [
    // {value : "1", label : "2.2m 이상 ~ 4m 미만"},
    {value : "4", label : "2.2m 이상 ~ 2.8m 미만"},
    {value : "5", label : "2.8m 이상 ~ 4m 미만"},
    {value : "2", label : "4m 이상 ~ 6m 미만"},
    {value : "3", label : "6m 초과"}
];

export const qnaDivision = [
    { value : "1", label : "견적"},
    { value : "2", label : "서비스"},
    { value : "3", label : "회원정보"},
    { value : "4", label : "AP 포인트"},
    { value : "5", label : "제품"},
];

export const varSquareMeter = [
    { value : "0", label : "미등록" },
    { value : "1", label : "10평 미만" },
    { value : "2", label : "10평 이상 ~ 20평 미만" },
    { value : "3", label : "20평 이상 ~ 30평 미만" },
    { value : "4", label : "30평 이상 ~ 40평 미만" },
    { value : "5", label : "40평 이상 ~ 50평 미만" },
    { value : "6", label : "50평 이상 ~ 60평 미만" },
    { value : "7", label : "60평 이상 ~ 70평 미만" },
    { value : "8", label : "70평 이상 ~ 80평 미만" },
    { value : "9", label : "80평 이상 ~ 90평 미만" },
    { value : "10", label : "90평 이상 ~ 100평 미만" },
    { value : "11", label : "100평 이상" },
];

export const varSpace = [
    { value : "1", label : "거실" },
    { value : "2", label : "주방 / 다이닝룸" },
    { value : "3", label : "침실" },
    { value : "4", label : "욕실" },
    { value : "5", label : "서재 / 공부방" },
    { value : "6", label : "아이방" },
    { value : "7", label : "베란다 / 발코니" },
    { value : "8", label : "다용도실" },
    { value : "9", label : "실외" },
    { value : "10", label : "기타" },
];

export const bnkAccount = [
    "주식회사 앰비언스",
    "부산은행) 113-2011-0981-05",
];

export const availableAreasWithinWeek = [
    '서울',
    '부산',
    '경기',
    '인천',
];

export const MIN_DAYS_MAJOR_AREA = 14;
export const MAX_DAYS_MAJOR_AREA = 31;

export const MIN_DAYS_OTHER_AREA = 21;
export const MAX_DAYS_OTHER_AREA = 50;

export const PROCESS_MANUAL_URL = `${API_URL}/files/files_folder/ablack_file/260618_ablack_process_manual.pdf`;